var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CourierForm',{attrs:{"courier":_vm.courier,"type":_vm.type,"buttonLoading":_vm.buttonLoading},on:{"saveCourier":_vm.updateCourier}})}
var staticRenderFns = []

export { render, staticRenderFns }